import {
    Column,
    ColumnChooser,
    Export,
    FilterBuilderPopup,
    FilterPanel,
    FilterRow,
    GroupPanel,
    Grouping,
    HeaderFilter,
    Pager,
    Paging,
    Scrolling,
    SearchPanel,
    Selection,
} from "devextreme-react/data-grid";
import "devextreme/dist/css/dx.light.css";
import { exportDataGrid } from "devextreme/excel_exporter";
import { exportDataGrid as exportDataGridToPdf } from "devextreme/pdf_exporter";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { jsPDF } from "jspdf";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import BaseDataGrid from "./BaseDataGrid";

// --- CHANGE 1: ADDED IMPORTS FOR COPY FUNCTIONALITY ---
import CopyIcon from "@mui/icons-material/FileCopy";
import { IconButton } from "@mui/material";
import copy from "copy-to-clipboard";
import { toISODateTime } from "../lib/util";

export default function OrdersDevExpressDataGrid(props) {
    const navigate = useNavigate();
    const dataTable = useRef(null);
    const gridHeight = "100%";

    const renderJobID = (params) => {
        if (params.value) {
            return (
                <a
                    style={{ color: "#1234b0" }}
                    href={`${window.location.origin}/orderDetail/${params.value}/${props.account}`}
                >
                    {params.value.substring(0, 10)}
                </a>
            );
        }
    };

    const renderTrackingURL = ({ data }) => {
        if (!data.TrackNumber) return null;

        const handleCopyClick = () => {
            const url = `https://tracking.directx.ca/trackNo/${data.TrackNumber}`;
            copy(url);
            alert(`Copied to clipboard: ${url}`); // Simple feedback for the user
        };

        return (
            <IconButton onClick={handleCopyClick} size="small" aria-label="copy tracking url">
                <CopyIcon style={{ color: "#1234b0", cursor: "pointer", height: "15px" }} />
            </IconButton>
        );
    };

    const onExporting = (e) => {
        console.log("onExporting-" + e.format);
        if (e.format === "xlsx") {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet("Orders");
            exportDataGrid({
                component: e.component,
                worksheet,
                autoFilterEnabled: true,
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: "application/octet-stream" }), "Orders.xlsx");
                });
            });
            e.cancel = true;
        } else if (e.format === "pdf") {
            const doc = new jsPDF();
            exportDataGridToPdf({
                jsPDFDocument: doc,
                component: e.component,
            }).then(() => {
                doc.save("Orders.pdf");
            });
        } else if (e.format === "csv") {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet("Orders");
            exportDataGrid({
                component: e.component,
                worksheet: worksheet,
            }).then(function () {
                workbook.csv.writeBuffer().then(function (buffer) {
                    saveAs(new Blob([buffer], { type: "application/octet-stream" }), "Orders.csv");
                });
            });
        }
    };

    const exportFormats = ["pdf", "xlsx", "csv"];

    const filterBuilderPopupPosition = {
        of: window,
        at: "top",
        my: "top",
        offset: { y: 10 },
    };

    const startViewDetail = (e) => {
        if (!e || !e.data || !e.data.jobID) {
            console.log("Invalid row data for view detail");
            return;
        }
        console.log("startViewDetail --" + JSON.stringify(e.data));
        console.log("Row data:", JSON.stringify(e.data, null, 2));
        navigate(`/orderDetail/${e.data.jobID}/${props.account}`);
    };

    return (
        <BaseDataGrid
            className={"gridContainer"}
            ref={dataTable}
            dataSource={props.orders}
            showBorders={true}
            allowColumnReordering={true}
            allowColumnResizing={true}
            columnResizingMode="widget"
            height={gridHeight}
            keyExpr="id"
            onCellDblClick={startViewDetail}
            onRowClick={(e) => {
                console.log("Row data:", JSON.stringify(e.data, null, 2));
            }}
            onExporting={onExporting}
            onRowPrepared={(e) => {
                if (
                    e.data &&
                    (e.data.Status === "Verified" || e.data.Status === "Delivered" || e.data.Status === "Invoiced")
                )
                    e.rowElement.style.backgroundColor = "#c6ecc6";
                else if (e.data && e.rowIndex % 2 === 0) e.rowElement.style.backgroundColor = "#FFFFFF";
                else if (e.data && e.rowIndex % 2 !== 0) e.rowElement.style.backgroundColor = "#E5E7E9";
            }}
        >
            <FilterPanel visible={true} />
            <FilterBuilderPopup position={filterBuilderPopupPosition} />
            <HeaderFilter visible={true} />
            <GroupPanel visible={true} />
            <Grouping autoExpandAll={false} />
            <SearchPanel visible={true} width={240} placeholder="Search..." />
            {/* <StateStoring
        enabled={true}
        type="localStorage"
        storageKey="ordersGridState_v3"
        savingTimeout={1000}
    /> */}
            <Selection mode="single" />
            <FilterRow visible={true} />
            <Paging defaultPageSize={35} />
            <Pager
                visible={true}
                allowedPageSizes={[20, 35, 60, "all"]}
                showPageSizeSelector={true}
                showInfo={true}
                infoText="Page #{0}. Total: {1} ({2} items)"
                displayMode="full"
            />

            <Scrolling rowRenderingMode="virtual"></Scrolling>

            {/* All other column changes from before are still here */}
            <Column dataField="jobID" caption="JobID" width={100} cellRender={renderJobID} />
            <Column dataField="Status" caption="Status" width={100} alignment="center" />
            <Column dataField="location" caption="Location" width={100} alignment="center" />
            <Column dataField="sCompanyName" caption="From" width={180} alignment="center" visible={true} />
            <Column dataField="sAddress" caption="Sh.Address" width={120} alignment="center" visible={true} />
            <Column dataField="sCity" caption="Sh.City" width={120} alignment="center" visible={true} />
            <Column dataField="cAddress" caption="Co.Address" width={120} alignment="center" visible={true} />
            <Column dataField="cCity" caption="Co.City" width={120} alignment="center" visible={true} />
            <Column
                dataField="dtDelivered_UTC"
                caption="Delivery Date/Time"
                width={180}
                dataType="datetime"
                format="yyyy-MM-dd HH:mm"
                alignment="center"
            />
            <Column dataField="PROOF_DEL" caption="Deli. Proof" width={130} alignment="center" />
            <Column
                dataField="dtCallIn_UTC"
                caption="Call Time"
                width={160}
                alignment="center"
                cellRender={({ data }) => {
                    return toISODateTime(data.dtCallIn_UTC);
                }}
            />
            <Column dataField="CALLER" caption="Caller" width={120} alignment="center" />
            <Column dataField="RATE" caption="Rate" width={75} alignment="center" />
            <Column
                dataField="dtDCT_UTC"
                caption="Due By"
                width={160}
                alignment="center"
                cellRender={({ data }) => {
                    return toISODateTime(data.dtCallIn_UTC);
                }}
            />
            <Column dataField="CUST_REF" caption="Reference" width={120} alignment="center" />
            <Column dataField="serviceText" caption="Service" width={120} alignment="center" />
            <Column dataField="cCompanyName" caption="To" width={180} alignment="center" visible={true} />
            <Column dataField="sContact" caption="Sh.Contact" width={120} alignment="center" visible={false} />
            <Column dataField="sPhone" caption="Sh.Phone" width={120} alignment="center" visible={false} />
            <Column dataField="cContact" caption="Co.Contact" width={120} alignment="center" />
            <Column dataField="last_driv" caption="Last Driver" width={120} alignment="center" visible={true} />
            <Column dataField="cPhone" caption="Co.Phone" width={120} alignment="center" />
            <Column dataField="PIECES" caption="Pieces" width={120} alignment="center" />
            <Column dataField="WEIGHT" caption="Weight" width={120} alignment="center" />
            <Column
                caption="BOL"
                dataField="BOLURL"
                width={80}
                alignment="center"
                cellRender={({ data }) => {
                    if (!data.BOLURL) return null;
                    return (
                        <a href={data.BOLURL} target="_blank" rel="noopener noreferrer">
                            <i className="dx-icon-download" style={{ color: "#1234b0" }} />
                        </a>
                    );
                }}
            />
            <Column caption="Track" width={80} alignment="center" cellRender={renderTrackingURL} />

            <ColumnChooser enabled={true} mode="select" />

            <Export enabled={true} formats={exportFormats} allowExportSelectedData={false} />
        </BaseDataGrid>
    );
}
